import { action, observable, set } from 'mobx';
import { IViewsOffers } from '~api/OffersAPI/IOffersApiSdk';
import ICartOffers from '~domain/entities/CartOffers/ICartOffers';
import IOffer from '~domain/entities/Offer/IOffer';
import Offers from '~domain/entities/Offers/Offers';
import { OffersComponentEnum } from '~utils/OffersEnum';

export default class CartOffers implements ICartOffers {
    @observable public qualifiedOffers: Offers;
    @observable public inCartOffers: Offers;
    @observable public notQualifiedOffers: Offers;
    @observable public appliedOffers: Offers;

    constructor() {
        this.qualifiedOffers = new Offers();
        this.notQualifiedOffers = new Offers();
        this.inCartOffers = new Offers();
        this.appliedOffers = new Offers();
    }

    public setQualifiedOffers = (qualified: Offers) => {
        this.qualifiedOffers = qualified;
    };

    public set setNotQualifiedOffers(notQualifiedOffers: Offers) {
        this.notQualifiedOffers = notQualifiedOffers;
    }

    public setInCartOffers(inCart: Offers) {
        this.inCartOffers = inCart;
    }

    public setAppliedOffers(appliedOffers: Offers) {
        this.appliedOffers = appliedOffers;
    }

    @action
    public shoppingBagTabCount() {
        const views = [this.qualifiedOffers];

        return views.reduce((total, view) => {
            return view
                ? total + this.countOffersInLocation(view.offers, OffersComponentEnum.CartLocation)
                : total;
        }, 0);
    }

    @action
    public offersTabTotalCount() {
        const views = [this.qualifiedOffers, this.notQualifiedOffers, this.inCartOffers];

        return views.reduce((total, view) => {
            return view
                ? total +
                      this.countOffersInLocation(view.offers, OffersComponentEnum.OffersLocation)
                : total;
        }, 0);
    }

    @action
    public offersTabQualifiedCount() {
        const views = [this.qualifiedOffers];
        const inCart = this.inCartOffers.offers?.length || 0;

        return (
            inCart +
            views.reduce((total, view) => {
                return view
                    ? total +
                          this.countOffersInLocation(
                              view.offers,
                              OffersComponentEnum.OffersLocation
                          )
                    : total;
            }, 0)
        );
    }

    private countOffersInLocation = (offerType: IOffer[], location: string) => {
        return offerType?.reduce((total, offer) => {
            return offer?.offerLocation?.includes(location) ? total + 1 : total;
        }, 0);
    };

    public static fromJSON(data: IViewsOffers, previousData?: ICartOffers) {
        const cartOffers = new CartOffers();

        const newOffers = Object.entries(data).reduce(
            (acc, [offerType, offers]) => ({
                ...acc,
                [offerType]: Offers.fromJSON(offers)
            }),
            {} as ICartOffers
        );

        set(cartOffers, { ...previousData, ...newOffers });

        return cartOffers;
    }
}
